import Backbone from 'backbone'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import formHelper from 'scoreboard/components/form-helper'
import selects from 'scoreboard/components/selects'
import template from './organization-template-permission-view.hbs'
import RollupTreeGroupActionsTable from 'scoreboard/admin/datasets/rollup-tree-group-actions-table'
import AdvancedPermissionsForm from 'scoreboard/admin/principals/groups/advanced-permissions-form'
import appDisplay from '../components/app-display'
import constants from 'scoreboard/components/constants'

const OrganizationTemplatePermissionView = Backbone.View.extend({
	className: 'panel organization-template-permissions-view',

	/** @type OrganizationTemplatePermission */
	model: null,

	events: {
		'click .rollup-tree-group-label a': 'onClickRollupTreeGroupLabel',
		'click .delete-permission': 'onClickDeletePermission',
		'click .actions': 'onClickActions',
		'change': 'onChange'
	},

	initialize (options = {}) {
		this.options = options
	},

	render() {
		this.$el.empty().append(template({
			label: this.options.rollupTreeGroup.label
		}))

		this.$('.group-type').append(groupType.renderSelect({
			name: 'groupType',
			value: this.model.get('groupType')
		}))

		formHelper.writeToDom(this.model, this.el)

		selects(this.$('select'))

		return this
	},

	onClickRollupTreeGroupLabel () {
		RollupTreeGroupActionsTable.dialog({
			rollupTreeGroupId: this.options.rollupTreeGroup.id,
			rollupTreeGroupLabel: this.options.rollupTreeGroup.label,
			treeRootId: this.options.rollupTreeGroup.treeRootId,
			banner: true,
			errorTooltipTarget: this.$('.rollup-tree-group-label')
		})
	},

	onClickDeletePermission () {
		this.trigger('delete')
	},

	onClickActions () {
		let form = new AdvancedPermissionsForm({
			model: this.model,
			type: this.model.get('groupType'),
			disabledPermissionIds: constants.disallowedOrganizationTemplatePermissionCodes,
			rollupTreeGroup: this.options?.rollupTreeGroup
		})

		appDisplay.dialog(form)
		this.listenTo(form, 'done', dirty => {
			if (dirty) {
				this.trigger('change')
			}
		})
	},

	onChange () {
		this.model.set(formHelper.readFromDom(this.el))
	}
})

export default OrganizationTemplatePermissionView

OrganizationTemplatePermissionView.__filename__ = 'organizations/organization-template-permission-view.js'
